import { computed, ref } from 'vue'
import { usePage } from '@inertiajs/vue3'

// Halloween (flag halloween, ends at midnight on 1 November in the member's
// time zone): the hat every face wears on the member's screen. The member
// picks it in the profile menu; the pick stays in this browser.
export type HalloweenHat = 'witch' | 'pumpkin' | 'ghost' | 'none'

export const HALLOWEEN_HATS: { value: HalloweenHat; label: string }[] = [
  { value: 'witch', label: 'Witch hat' },
  { value: 'pumpkin', label: 'Pumpkin' },
  { value: 'ghost', label: 'Ghost' },
  { value: 'none', label: 'No hat' },
]

const STORAGE_KEY = 'gm-halloween-hat'

const readHat = (): HalloweenHat => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    return HALLOWEEN_HATS.some((option) => option.value === saved)
      ? (saved as HalloweenHat)
      : 'witch'
  } catch {
    return 'witch'
  }
}

// One pick for the whole app, so every face changes at once.
const hat = ref<HalloweenHat>(readHat())

export const useHalloween = () => {
  const page = usePage()
  const enabled = computed(
    () => !!page.props.shared?.featureFlags?.halloweenEnabled,
  )

  const setHat = (value: HalloweenHat) => {
    hat.value = value
    try {
      window.localStorage.setItem(STORAGE_KEY, value)
    } catch {
      // Private window: the pick lasts for this visit.
    }
  }

  return { enabled, hat, setHat }
}
